import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=a1f89ea8&scoped=true"
import script from "./StatusChip.vue?vue&type=script&lang=ts"
export * from "./StatusChip.vue?vue&type=script&lang=ts"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=a1f89ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f89ea8",
  null
  
)

export default component.exports